import { render } from "./ConfermaCodiceDueFattori.vue?vue&type=template&id=5ab5c05a&scoped=true"
import script from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"
export * from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"

import "./ConfermaCodiceDueFattori.vue?vue&type=style&index=0&id=5ab5c05a&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab5c05a"]])

export default __exports__